import { render, staticRenderFns } from "./withdrawal-form.vue?vue&type=template&id=05d62360&scoped=true"
import script from "./withdrawal-form.vue?vue&type=script&lang=ts"
export * from "./withdrawal-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d62360",
  null
  
)

export default component.exports